<template>
  <div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 4rem; height: 4rem;" variant="info"></b-spinner>
		</div>
    <div v-else class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header">
            <div slot="header"><i class="fa fa-dollar"></i> Add Payment</div>
            <b-form @submit.prevent="checkFormValidity()" method="post">
              <b-form-group
                label="Select Invoice"
                label-for="unpaidInvoiceList"
								label-class="required"
                :label-cols="3"
                :horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.invoiceId.$dirty ? !$v.form.invoiceId.$error : null">
								<model-select id="unpaidInvoiceList" :options="unpaidInvoiceList" v-model="form.invoiceId" :isError="$v.form.invoiceId.$dirty ? $v.form.invoiceId.$error : false" placeholder="Please Select"></model-select>
              </b-form-group>
              <b-form-group
                label="Amount"
                label-for="amount"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.amount" name="amount" id="amount" type="number" placeholder="Amount" min="1" :state="$v.form.amount.$dirty ? !$v.form.amount.$error : null" aria-describedby="amount-live-feedback"></b-form-input>
                <b-form-invalid-feedback id="amount-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
              </b-form-group>
							<b-form-group
								label="Discount"
								label-for="discount"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.discount" name="discount" id="discount" type="number" placeholder="Discount"></b-form-input>
							</b-form-group>
              <b-form-group
                label="Payment Date" label-for="paymentDate"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.paymentDate" name="paymentDate" type="date" id="paymentDate" :state="$v.form.paymentDate.$dirty ? !$v.form.paymentDate.$error : null" aria-describedby="paymentDate-live-feedback"></b-form-input>
                <b-form-invalid-feedback id="paymentDate-live-feedback">This is a required field.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label="Remarks"
                label-for="remarks"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.remarks" id="remarks" :textarea="true" :rows="9" placeholder="Content.." :state="$v.form.remarks.$dirty ? !$v.form.remarks.$error : null" aria-describedby="remarks-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="remarks-live-feedback">Remarks can not be more than 100 characters.</b-form-invalid-feedback>
              </b-form-group>
              <div class="form-actions">
                <b-button type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> New Payment Received</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>

			<payment-histories :payment-status="0" :unpaid-invoice-list="unpaidInvoiceList" :reload-method="reload"></payment-histories>
			<payment-histories :payment-status="1"></payment-histories>
			<payment-histories :payment-status="-1"></payment-histories>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required, numeric, minValue, maxLength } from 'vuelidate/lib/validators';
import paymentService from '@/services/paymentService';
import invoiceService from '@/services/invoiceService';
import genericTable from '@/components/GenericTable';
import toastService from "@/services/toastService";
import {ModelSelect} from "vue-search-select";
import PaymentHistories from "@/components/PaymentHistories.vue";

export default {
  name: 'payment',
	components: {
		PaymentHistories,
		"genericTable": genericTable,
		ModelSelect
	},
  data: function () {
    return {
      form: {
        invoiceId: null,
        amount: null,
				discount: null,
        paymentDate: null,
        remarks: null,
      },
      unpaidInvoiceList: [],
			loading : false,
    }
  },

  validations: {
    form: {
      invoiceId: {
        required,
        minValue: minValue(1)
      },
      amount: {
        required,
        numeric,
        minValue: minValue(1)
      },
      paymentDate: {
        required
      },
			remarks: {
      	maxLength: maxLength(100)
			}
    }
  },

	created(){
		this.init();
	},


  methods: {
		init: function () {
			this.loading = true;
			Promise.all([this.getUnpaidInvoiceList()]).then(() => {
				this.loading = false;
			});
		},
    checkFormValidity: function(){
      let formHasErrors = false;

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        formHasErrors = true;
      }

      if(formHasErrors) return;
      else this.addNewPayment();
    },

    addNewPayment: function () {
      let paymentDateInMillis = new moment(this.form.paymentDate,'YYYY-MM-DD');
      const formData = {
				invoiceId: this.form.invoiceId,
				paidAmount: this.form.amount,
				discountedAmount: this.form.discount,
				paymentDate: paymentDateInMillis.format('x'),
				remarks: this.form.remarks,
				paymentReceiverId: 0
			};

			paymentService.addPaymentForAnInvoice(formData, (data) => {
				this.reload();
				toastService.showSuccessToast("Payment added successfully.")
			}, (error) => {
				toastService.showErrorToast("Could not store payment history " + error);
			});

			return false;
    },

		getUnpaidInvoiceList: function () {
			this.unpaidInvoiceList = [];
			return invoiceService.getUnpaidInvoiceListNonPaginated((data) => {
				this.unpaidInvoiceList = this.createInvoiceDropDownList(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch invoice list" + error);
			});
		},

		createInvoiceDropDownList: function (data) {
    	let invoiceList = [ {text: 'Please select', value: null} ];
			data.forEach((value, index) => {
				let invoice = new Object();
				invoice.text = "Invoice# " + value.invoiceNumber + ", Project Name: " + value.subscriberProjectName;
				invoice.value = value.id;
				invoiceList.push(invoice);
			});

			return invoiceList;
		},

		resetForm: function () {
			this.form.invoiceId = null;
			this.form.amount = null;
			this.form.discount = null;
			this.form.paymentDate = null;
			this.form.remarks = null;
			// this.$v.reset();
		},

		reload: function () {
			this.resetForm();
			this.$nextTick(() => { this.$v.$reset() });
			this.init();
		},

		downloadInvoice : function (paymentHistoryId) {
			paymentService.downloadInvoice(paymentHistoryId, (data) => {

			}, (error) => {
				toastService.showErrorToast("Could not download invoice");
			});
		}
  }
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
